module.exports = __webpack_public_path__ + "static/media/Group 51743@2x.9cf53540.png";